
import { Component, Vue } from 'vue-property-decorator';
import isImageSizeValid from '@/util/is-image-size-valid';
import SingleImageUpload from '@/component/single-image-upload.vue';
import { UPLOAD_DIR } from '@/constants';

const { VUE_APP_FCAPI: FCAPI } = process.env;
const API = {
  query: `${FCAPI}/boss/ruan/slider`,
};
const OPTION_LIST = [
  {
    title: '排序',
    align: 'center',
    width: '200px',
    dataIndex: 'sort',
  },
  {
    dataIndex: 'image_url',
    align: 'center',
    slots: { title: 'customTitle' },
    scopedSlots: { customRender: 'image' },
  },
];
const DATA = [
  {
    id: 1,
    sort: 1,
    image_url: '',
  },
  {
    id: 2,
    sort: 2,
    image_url: '',
  },
  {
    id: 3,
    sort: 3,
    image_url: '',
  },
  {
    id: 4,
    sort: 4,
    image_url: '',
  },
  {
    id: 5,
    sort: 5,
    image_url: '',
  },
  {
    id: 6,
    sort: 6,
    image_url: '',
  },
];
@Component({
  components: {
    SingleImageUpload,
  },
})
export default class Swiper extends Vue {
  data: any = DATA;
  columns = OPTION_LIST;
  is_loading = false;
  img_url = '';
  UPLOAD_DIR = UPLOAD_DIR;
  preview_image = '';
  preview_visible = false;

  created() {
    this.query();
  }
  // 提交编辑数据
  async submit() {
    let send_data = {
      data: this.data,
    };
    const { data } = await this.$axios.put(`${API.query}/999999`, send_data);
    if (data.status !== 200) {
      this.$message.error(data.message);
      return;
    }
    this.$message.success('保存成功');
    this.query();
  }
  // 查询轮播列表
  async query() {
    this.is_loading = true;
    const { data } = await this.$axios.get(API.query);
    this.is_loading = false;
    if (data.status !== 200) return;
    const arr = data.data;
    this.data.forEach((item: any) => {
      arr.forEach((_item: any) => {
        if (item.id === _item.id) {
          item.image_url = _item.image_url;
        }
      });
    });
  }

  // 预览
  handlePreview(imageUrl: string) {
    this.preview_image = imageUrl;
    this.preview_visible = true;
  }
  handlePreviewCancel() {
    this.preview_visible = false;
  }
  // 图片上传前
  beforeIndexImgUpload(file: any) {
    if (file.size / 1024 > 2048) {
      this.$message.error('图片过大，请上传 2M 以内图片');
      return false;
    }
    return isImageSizeValid(
      file,
      (width: number, height: number) => width === 670 && height === 240
    ).catch((data: any) => {
      const { width, height } = data;
      this.$message.error(
        `图片宽高限定 670*240px，当前上传图片宽高为 ${width}*${height}`
      );
      return Promise.reject(null);
    });
  }
}
